// extracted by mini-css-extract-plugin
module.exports = {"Slider":"HowTo_Slider__2mSup"};